// extracted by mini-css-extract-plugin
export var notificationHost = "_ei-0";